import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Daily Active Initiator Machines ")

import { IncrediCard, IncrediChartBar } from 'incredi-ui';
import { computed } from 'vue';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { dataZoomSliderOff } from '@/views/dashboard/dashboard.charts.utils';
import DashboardChartTitle from '@/views/dashboard/components/dashboard-chart-title.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'daily-active-initiator-machines',
  props: {
    chartOptions: null
  },
  setup(__props: any) {

const props = __props as {
  chartOptions: InstanceType<typeof IncrediChartBar>['$props'];
}


const chartProps = computed(() => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { options, ...rest } = props.chartOptions;

  return rest;
});

const tooltip = [
  {
    description: ['Agents missing Initiator roles are machines that', 'initiated builds but did not receive acceleration'],
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _createVNode(_unref(IncrediCard), { class: "relative h-full p-[16px] !shadow-none border border-Border/border_natural" }, {
        default: _withCtx(() => [
          _createVNode(DashboardChartTitle, {
            absolute: "",
            tooltip: tooltip
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_unref(IncrediChartBar), _mergeProps({
            height: "284px",
            options: {
          dataZoom: _unref(dataZoomSliderOff),
          ...(__props.chartOptions.options || {}),
        }
          }, _unref(chartProps)), null, 16, ["options"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})